import { registerSW } from 'virtual:pwa-register'

export default function registerSw() {
    registerSW({ immediate: true }) // Registra o Service Worker automaticamente
}
